/**
 * @voltxampere/ui — Photo-resistor (LDR) 7mm hobby variant (Sprint 51-1 polish)
 *
 * Larger 7mm GL5528-style cadmium-sulfide light-dependent resistor.
 * Resistance ~1MΩ in dark → ~10kΩ in bright light. Counterpart to
 * the smaller LDR shipped Sprint 43.
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (resistance changes modeled at sensor activation layer; MNA stamp
 * sees fixed resistor for DC analysis).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const sensorLdr7mm = {
    id: "ldr-7mm",
    nameTr: "Foto-Direnç 7mm (LDR, hobi)",
    nameEn: "Photo-Resistor 7mm (LDR, hobby)",
    shortcut: "L",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "LDR",
    defaultValue: "10kΩ",
    schemaType: "potentiometer",
    defaultParams: {
        resistance: 10000,
        wiperPosition: 0.5,
        package: "GL5528 7mm",
        darkResistanceMohm: 1.0,
        brightResistanceKohm: 10,
        chemistry: "CdS",
    },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=sensor-ldr-7mm.js.map